import { render, staticRenderFns } from "./claim-assign.vue?vue&type=template&id=4b47b0ba&"
import script from "./claim-assign.vue?vue&type=script&lang=ts&"
export * from "./claim-assign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports